module.exports = __webpack_public_path__ + "static/media/layers-visible.643484bd.png";